import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import type { CustomerAddressHandOffState } from 'src/modules/booking/types/customer-address-hand-off.types'

// History state survives reloads and session restore, so the address lives in memory only.
export function useCustomerAddressHandOff(): string | null {
  const location = useLocation()
  const navigate = useNavigate()
  const [customerAddress] = useState(() => readCustomerAddress(location.state))
  const isAddressInHistory = readCustomerAddress(location.state) !== null

  useEffect(() => {
    if (!isAddressInHistory) return
    navigate(location.pathname, { replace: true, state: null })
  }, [isAddressInHistory, location.pathname, navigate])

  return customerAddress
}

function readCustomerAddress(state: unknown): string | null {
  const address = (state as Partial<CustomerAddressHandOffState> | null)?.customerAddress
  return typeof address === 'string' && address.trim() ? address : null
}
